var map = {
	"./address_image.svg": 85,
	"./angelo_profile.jpg": 86,
	"./bau_logo.png": 87,
	"./blogs_image.svg": 88,
	"./cloud_infrastructure.svg": 89,
	"./codeInLogo.png": 90,
	"./code_thinking.svg": 91,
	"./contactMail.png": 92,
	"./coursera_logo.png": 93,
	"./data_science.svg": 94,
	"./deeplearning_ai_logo.png": 95,
	"./delhivery_logo.png": 96,
	"./dev_productivity.svg": 97,
	"./developerActivity.svg": 98,
	"./dsc_logo.png": 99,
	"./education.svg": 100,
	"./experience.svg": 101,
	"./feelingProud.svg": 102,
	"./freecopy_logo.png": 103,
	"./fullstack.svg": 104,
	"./gcp_logo.png": 105,
	"./github_logo.png": 106,
	"./going_up.svg": 107,
	"./googleAssistant.jpg": 108,
	"./googleAssistant.svg": 109,
	"./google_logo.png": 110,
	"./ibm_logo.png": 111,
	"./intel_logo.jpg": 112,
	"./jsFramework.svg": 113,
	"./legato_logo.png": 114,
	"./manOnTable.svg": 115,
	"./microsoft_logo.png": 116,
	"./mozilla_logo.png": 117,
	"./muffito_logo.png": 118,
	"./programmer.svg": 119,
	"./programming.svg": 120,
	"./projects_image.svg": 121,
	"./pwa.png": 122,
	"./stanford_logo.png": 123,
	"./talksCardBack.svg": 124,
	"./talksCardBackAlt.svg": 125,
	"./ui_ux_design.svg": 126
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20;